import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=2ecd789e&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=2ecd789e&lang=scss&scoped=true&"
import style1 from "./OrderList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd789e",
  null
  
)

export default component.exports